'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaMailReplyAll = function FaMailReplyAll(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.3 24.2v1.5q0 1-0.9 1.3-0.3 0.1-0.5 0.1-0.6 0-1-0.4l-11.5-11.4q-0.4-0.4-0.4-1t0.4-1l11.5-11.4q0.6-0.7 1.5-0.4 0.9 0.4 0.9 1.4v1.5l-8.9 8.9q-0.4 0.4-0.4 1t0.4 1z m25.7 0.8q0 1.3-0.4 3t-0.8 3.1-1.1 2.8-0.9 2l-0.5 0.9q-0.1 0.3-0.6 0.3-0.1 0-0.2 0-0.5-0.2-0.5-0.7 1-9-2.4-12.6-1.4-1.6-3.8-2.5t-5.9-1.2v5.6q0 1-0.9 1.3-0.3 0.1-0.6 0.1-0.6 0-1-0.4l-11.4-11.4q-0.4-0.4-0.4-1t0.4-1l11.4-11.4q0.7-0.7 1.6-0.4 0.9 0.4 0.9 1.4v5.8q9.1 0.6 13.3 4.9 3.8 3.9 3.8 11.4z' })
        )
    );
};

exports.default = FaMailReplyAll;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/mail-reply-all.js
// module id = 1677
// module chunks = 0